// src/components/layout/Sidebar.tsx
// VERSIÓN ACTUALIZADA — agrega ítem "Subastas en Vivo" al menú

import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import { logout } from "../../store/slices/authSlice";
import logoLight from "../../assets/images/logo-feriagana-light.svg";

interface Props {
  collapsed: boolean;
  mobileOpen: boolean;
  onToggle: () => void;
  onMobileClose: () => void;
  retirosPendientes: number;
  disputasAbiertas: number;
}

interface NavItem {
  to: string;
  icon: string;
  label: string;
  badge?: number;
}

const navItems: NavItem[] = [
  { to: "/dashboard", icon: "bi-grid-1x2-fill", label: "Dashboard" },
  { to: "/subastas", icon: "bi-hammer", label: "Subastas en Vivo" },
  {
    to: "/usuarios-subasta",
    icon: "bi-person-check-fill",
    label: "Aprobación Subastas",
  }, // ✅ NUEVO
  { to: "/retiros", icon: "bi-cash-coin", label: "Retiros" },
  { to: "/disputas", icon: "bi-shield-exclamation", label: "Disputas" },
  { to: "/wallets", icon: "bi-wallet2", label: "Wallets MVZ" },
  { to: "/comisiones", icon: "bi-receipt", label: "Comisiones" },
  {
    to: "/mvz-verificacion",
    icon: "bi-patch-check",
    label: "MVZ Verificación",
  },
  {
    to: "/verificaciones",
    icon: "bi-person-vcard",
    label: "Verificaciones",
  },
  {
    to: "/corrales-pricing",
    icon: "bi-cash-stack",
    label: "Precios de Corral",
  },
  {
    to: "/corrales-cupones",
    icon: "bi-ticket-perforated",
    label: "Cupones de Corral",
  },
];

export default function Sidebar({
  collapsed,
  mobileOpen,
  onToggle,
  onMobileClose,
  retirosPendientes,
  disputasAbiertas,
}: Props) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const user = useAppSelector((s) => s.auth.user);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  const items = navItems.map((item) => ({
    ...item,
    badge:
      item.to === "/retiros"
        ? retirosPendientes
        : item.to === "/disputas"
          ? disputasAbiertas
          : undefined,
  }));

  return (
    <>
      {/* Backdrop móvil */}
      <div
        className="sidebar-backdrop"
        style={{ display: mobileOpen ? "block" : "none" }}
        onClick={onMobileClose}
      />

      <aside
        className={`sidebar ${collapsed ? "collapsed" : ""} ${mobileOpen ? "mobile-open" : ""}`}
      >
        {/* Header */}
        <div className="sidebar-header">
          {!collapsed ? (
            <div className="sidebar-logo">
              <img
                src={logoLight}
                alt="Feriagana"
                style={{ height: 44, width: "auto", display: "block" }}
              />
            </div>
          ) : (
            <div className="sidebar-logo-collapsed">
              <img
                src={logoLight}
                alt="Feriagana"
                style={{ height: 32, width: "auto", display: "block" }}
              />
            </div>
          )}
          <button
            className="sidebar-toggle"
            onClick={onToggle}
            title="Colapsar menú"
          >
            <i
              className={`bi ${collapsed ? "bi-layout-sidebar-inset" : "bi-layout-sidebar-inset-reverse"}`}
              style={{ fontSize: "1.2rem" }}
            />
          </button>
        </div>

        {/* Navigation */}
        <nav className="sidebar-nav">
          {!collapsed && (
            <div className="sidebar-section-title">MENÚ PRINCIPAL</div>
          )}

          {items.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `sidebar-item ${isActive ? "active" : ""}`
              }
              onClick={onMobileClose}
              title={collapsed ? item.label : undefined}
            >
              <i className={`bi ${item.icon}`} />
              {!collapsed && <span>{item.label}</span>}
              {!collapsed && item.badge && item.badge > 0 ? (
                <span className="sidebar-badge">{item.badge}</span>
              ) : null}
              {collapsed && item.badge && item.badge > 0 ? (
                <span
                  style={{
                    position: "absolute",
                    top: 6,
                    right: 6,
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    background: "var(--fg-orange)",
                    flexShrink: 0,
                  }}
                />
              ) : null}
            </NavLink>
          ))}

          {!collapsed && (
            <div className="sidebar-section-title" style={{ marginTop: 8 }}>
              CONFIGURACIÓN
            </div>
          )}

          <NavLink
            to="/configuracion"
            className={({ isActive }) =>
              `sidebar-item ${isActive ? "active" : ""}`
            }
            onClick={onMobileClose}
            title={collapsed ? "Configuración" : undefined}
          >
            <i className="bi bi-gear" />
            {!collapsed && <span>Configuración</span>}
          </NavLink>
        </nav>

        {/* Footer con usuario */}
        <div className="sidebar-footer">
          {!collapsed && user && (
            <div style={{ marginBottom: 12 }}>
              <div
                style={{
                  fontSize: "0.8rem",
                  color: "rgba(255,255,255,0.9)",
                  fontWeight: 600,
                }}
              >
                {user.firstName} {user.lastName}
              </div>
              <div
                style={{ fontSize: "0.72rem", color: "rgba(255,255,255,0.5)" }}
              >
                {user.email}
              </div>
            </div>
          )}
          <button
            className="sidebar-item"
            onClick={handleLogout}
            style={{ color: "rgba(255,100,100,0.9)" }}
            title={collapsed ? "Cerrar sesión" : undefined}
          >
            <i className="bi bi-box-arrow-right" />
            {!collapsed && <span>Cerrar sesión</span>}
          </button>
        </div>
      </aside>
    </>
  );
}
